import React from 'react';
import { connect } from 'react-redux';
import {
  adminFetchPoliciesRequestAction,
  adminIsLoadedSelector,
  adminSetPoliciesAction,
  extractPolicy,
  PermissionElementAttrEnum,
  policiesSelector,
  rebuildPermissions,
  rebuildPolicies,
  RightsPageView,
} from 'pages/administration.page';
import { permissionModel } from 'common/api/models/website';
import { getUploadFeatureSelector, websiteSelector } from 'common/selectors';

export const RightsPage = connect(
  (state) => ({
    website: websiteSelector(state),
    policies: policiesSelector(state),
    adminIsLoaded: adminIsLoadedSelector(state),
    withUpload: getUploadFeatureSelector(state),
  }),
  (dispatch) => ({
    getPolicies: (websiteId) => dispatch(adminFetchPoliciesRequestAction(websiteId)),
    setPolicies: (policies) => dispatch(adminSetPoliciesAction(policies)),
  })
)(
  class extends React.Component {
    componentDidMount() {
      if (!this.props.adminIsLoaded) this.props.getPolicies(this.props.website.id);
    }

    onRightChangeHandler = (event) => {
      const policyId = +event.target.getAttribute(PermissionElementAttrEnum.POLICY_ID);
      const permissionName = event.target.getAttribute(PermissionElementAttrEnum.PERMISSION_NAME);
      const currentPolicy = extractPolicy(this.props.policies, policyId);

      const policies = rebuildPolicies(this.props.policies, {
        ...currentPolicy,
        permissions: rebuildPermissions(currentPolicy.permissions, permissionModel({ name: permissionName })),
      });

      // Set policies in store
      this.props.setPolicies(policies);
    };

    render() {
      return (
        <RightsPageView
          withUpload={this.props.withUpload}
          policies={this.props.policies}
          onRightChangeHandler={this.onRightChangeHandler}
        />
      );
    }
  }
);
